import React from "react";
import classNames from "classnames";

// Login page styles
const loginStylerClasses = `
  flex flex-1 bg-white justify-center flex-col
  [&_ul.no-bullets]:list-none [&_ul.no-bullets]:p-0 [&_ul.no-bullets]:m-0
  [&_.login-content]:mx-auto [&_.login-content]:w-[min(397px,90%)] [&_.login-content]:flex
  [&_.login-content]:justify-center [&_.login-content]:flex-col [&_.login-content]:max-w-[397px]
  max-[992px]:[&_.login-content]:justify-start max-[992px]:[&_.login-content]:pt-20
  [&_.login-content_.logo-wrapper]:flex [&_.login-content_.logo-wrapper]:flex-col
  [&_.login-content_.logo-wrapper]:justify-center [&_.login-content_.logo-wrapper]:items-center
  [&_.login-content_.logo-wrapper]:justify-self-center [&_.login-content_.logo-wrapper_img]:mb-[30px]
  [&_.login-content_.ant-form-horizontal]:flex [&_.login-content_.ant-form-horizontal]:justify-center
  [&_.login-content_.ant-form-horizontal]:items-center [&_.login-content_.ant-form-horizontal]:flex-col
  [&_.login-content_.ant-form-horizontal]:gap-[15px]
  [&_.login-content_input]:bg-[#f7f7f7] [&_.login-content_input]:border-0 [&_.login-content_input]:box-border
  [&_.login-content_input]:w-full [&_.login-content_input]:p-5 [&_.login-content_input]:rounded-[30px]
  [&_.login-content_input]:!text-[var(--primary)] [&_.login-content_input]:mx-auto
  [&_.login-content_input:focus]:!text-[var(--primary)]
  [&_.login-content_input::placeholder]:!text-[var(--primary)]
  [&_.login-content_input:focus]:!outline-none [&_.login-content_select:focus]:!outline-none
  [&_.login-content_textarea:focus]:!outline-none [&_.login-content_button:focus]:!outline-none
  [&_.login-content_.login-button]:!w-full [&_.login-content_.login-button]:!h-[50px]
  [&_.login-content_.login-button]:!rounded-[30px] [&_.login-content_.login-button]:border-0
  [&_.login-content_.login-button]:!font-[Manrope,serif] [&_.login-content_.login-button]:!text-base
  [&_.login-content_.login-button]:!font-normal [&_.login-content_.login-button]:!leading-[22px]
  [&_.login-content_.login-button.disabled]:bg-[#eaeaea] [&_.login-content_.login-button.disabled]:text-[#888888]
`;

export default function LoginStyler({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={classNames(loginStylerClasses, className)}>{children}</div>;
}
